export default __webpack_public_path__ + "static/media/regulatory--atvs-permitted--g1.d5fe6ec3.png";